class ValueAdderButtonListener extends AbstractInputListener
{

    listen()
    {
        let context = this;
        $(document).on('click', context.selector, function (){


            let current = $(this);

            let value = parseFloat(current.attr('data-value'));

            let connected_input = $(`#${current.attr('data-id')}`);

            let input_value = MaskMoneyHelper.interface.unmask_field(connected_input);

            let new_value = input_value + value;

            MaskMoneyHelper.interface.set_value(connected_input, new_value);



            connected_input.trigger('change');
        });

    }

}